/** A history with points but no USD value at all: its prices couldn't be read. A `0` is a value. */
export function isUsdHistoryUnavailable(points: readonly { assetsUsd: number | null }[]): boolean {
  return points.length > 0 && points.every(({ assetsUsd }) => assetsUsd === null)
}
